import { danger } from '../../../../../utils/brand-colors';

export default () => ({
  cardButtonContainer: {
    display: 'block',
    textAlign: 'right',
    bottom: 0,
  },
  subscriptionCard: { height: '100%' },
  deactiveButton: { color: danger.light },
  subscriptionMessageContainer: { textAlign: 'center' },
  progressButton: { marginRight: 8 },
  sensorPlanSection: { textAlign: 'center' },
  subscribeToSensorCollectionButton: {
    marginLeft: '2rem',
    marginTop: 24,
  },
  sensorCollectionDivider: { marginBottom: '2rem' },
  periodFormControl: { textAlign: 'center' },
  billingPeriodSavings: { textAlign: 'center' },
  periodGroup: {
    textAlign: 'center',
    display: 'inline-block',
  },
  slider: { maxWidth: 200 },
  sliderGridContainer: { marginTop: '2rem' },
  periodRadio: { fontSize: '1.25rem' },
  paidUsersInputConatiner: { textAlign: 'center' },
  paidUsersInput: {
    width: 125,
    marginBottom: '0.35em',
  },
});
